import { render, staticRenderFns } from "./CreateEditFornecedorModal.vue?vue&type=template&id=7dfeb81f&"
import script from "./CreateEditFornecedorModal.vue?vue&type=script&lang=js&"
export * from "./CreateEditFornecedorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports